/* istanbul ignore file */
// components
import { RelatedOpportunitiesList } from 'domain/sales/opportunity';
import ContactsMenu from 'domain/sales/contact/shared/ContactsMenu';
import ContactRelatedOpportunitiesBreadcrumbs from 'domain/sales/contact/Show/ContactRelatedOpportunitiesBreadcrumbs';
import ContactEntityHeader from 'domain/sales/contact/shared/ContactEntityHeader';
import { ShowPageLayout } from 'framework/ui/layout';
// services
import { useShowContext } from 'framework/show';

const ContactOpportunities = () => {
  const { data } = useShowContext();

  const getDataMethod = async () => {
    return {
      result: data.getValueBySource('opportunities'),
    };
  };

  return (
    <ShowPageLayout
      menu={<ContactsMenu />}
      breadcrumbs={<ContactRelatedOpportunitiesBreadcrumbs />}
      entityHeader={<ContactEntityHeader />}
    >
      <RelatedOpportunitiesList getDataMethod={getDataMethod} />
    </ShowPageLayout>
  );
};

export default ContactOpportunities;
